import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"

import HeaderBg from "../images/life-insurance-bg.png"
import { StaticImage } from "gatsby-plugin-image"

export default function LifeInsurance(editorials) {
  return (
    <Layout>
      <SEO
        title={"Ensure The Financial Security For Your Family"}
        description={
          "Confidence creates peace of mind, allowing you to live your life to the fullest. No one is immune to accidents no matter how young or healthy."
        }
      />
      <div className="page-header">
        <div className="container">
          <div className="row no-gutters">
            <div className="col-xl-10">
              <div className="header-text">
                <h1 className="text-black mb-4">
                  Ensure The Financial Security For Your Family
                </h1>
                <p className="lead">
                  Confidence creates peace of mind, allowing you to live your
                  life to the fullest. No one is immune to accidents no matter
                  how young or healthy. Ensure financial protection for your
                  family in the event of your passing.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          className="header-bg"
          style={{ backgroundImage: `url(${HeaderBg})` }}
        />
      </div>
      <div className="section_padding family-insurance">
        <div className="container">
          <div className="row d-flex align-items-center">
            <div className="col-12 col-lg-6">
              <StaticImage
                className="my-3"
                src="../images/family-insurance.jpg"
              />
            </div>
            <div className="col-12 col-lg-6">
              <div className="p-5">
                <h2 className="section-title">Protect Your Family’s Future</h2>
                <p>
                  It's impossible to say which type of life insurance is better
                  because the kind of coverage that's right for you depends on
                  your unique circumstances and financial goals. But remember,
                  the best way to figure out the amount and type of life
                  insurance that makes sense for your particular situation is to
                  meet with a qualified life insurance professional.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section_padding insurance-type">
        <div className="container">
          <div className="row justify-content-evenly">
            <div className="col-lg-8 text-center mx-auto mb-5">
              <h2 className="section-title">
                There are many kinds of life insurance, but they generally fall
                into two categories: term insurance and permanent insurance.
              </h2>
            </div>
            <div className="col-md-6 col-lg-5 mb-4">
              <div className="insurance-category text-center">
                <h3>Term</h3>
                <p>
                  Term insurance is designed to meet temporary needs. It
                  provides protection for a specific period of time (the "term")
                  and generally pays a benefit only if you die during the term.
                  This type of insurance often makes sense when you have a need
                  for coverage that will disappear at a specific point in time.
                  For instance, you may decide that you only need coverage until
                  your children graduate from college or a particular debt is
                  paid off, such as your mortgage.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-5 mb-4">
              <div className="insurance-category text-center">
                <h3>Permanent</h3>
                <p>
                  In contrast, permanent insurance provides lifelong protection.
                  As long as you pay the premiums, and no loans, withdrawals or
                  surrenders are taken, the full face amount will be paid.
                  Because it is designed to last a lifetime, permanent life
                  insurance accumulates cash value and is priced for you to keep
                  over a long period of time Your premiums never go up, even as
                  you age or if your health status changes, and your policy
                  accumulates cash value over time.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section_padding position-relative bg_dark_parimary plan-insurance">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 mx-auto text-center">
              {/* <h2 className="section-title  text-left mb-3 text-white">
                Awards and Recognitions
              </h2> */}
              <h4 className="text-center text-white mb-5">
                Plan today for the uncertainties of tomorrow. The best way to
                start learning about your options is by seeing how easy it can
                be to get that protection.
              </h4>
              <a
                href="https://agents.ethoslife.com/invite/fa4fd"
                target="_blank"
                className="solid-btn my-3"
              >
                LEARN MORE
              </a>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}
